import SecuritySnaresIntegration from './SecuritySnaresIntegration';

export { SecuritySnaresIntegration };
export default SecuritySnaresIntegration;
